import Vue from 'vue'
import VueRouter from 'vue-router'
import route from '../store/index'
import api from '../api/index'
Vue.use(VueRouter)
const routes=[
  {
    path: '/',
    name:'Layout',
    component:() => import('../layout.vue'),
    redirect:{name:'index'},
    children:[
      {
        path:"/blank",
        name:"blank",
        component: () => import('../views/index/blank.vue')
      },
      {
        path:"/index",
        name:"index",
        component: () => import('../views/index/index.vue')
      },
    ]
  },
  // {
  //   path: '/Login',
  //   name: 'Login',
  //   component: () => import('../login.vue')
  // },
]

const router = new VueRouter({
  routes
})
// 路由拦截
router.beforeEach((to,from,next) =>{
  next()
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js